var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1914 51.6699V65H30.5957V61.1914H57.3828V51.6699H61.1914Z",
    fill: "#47568C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1914 51.6699V65H32.5V61.1914H57.3828V51.6699H61.1914Z",
    fill: "#F2F4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 3.80859C14.6209 3.80859 0 16.525 0 34.4043L1.94061 36.3086L3.80859 34.4043C3.80859 18.6285 16.7242 7.61719 32.5 7.61719C48.2758 7.61719 61.1914 18.6285 61.1914 34.4043L63.172 36.3086L65 34.4043C65 16.525 50.3791 3.80859 32.5 3.80859Z",
    fill: "#F2F4FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1914 34.4043L63.172 36.3086L65 34.4043C65 16.525 50.3791 3.80859 32.5 3.80859V7.61719C48.2758 7.61719 61.1914 18.6285 61.1914 34.4043Z",
    fill: "#F2F4FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.4043H13.3301V53.5742H0V34.4043Z",
    fill: "#CDD5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6699 34.4043H65V53.5742H51.6699V34.4043Z",
    fill: "#98B5EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7615 7.02394C46.9871 2.42874 39.8975 0 32.4999 0C25.1022 0 18.0126 2.42874 12.2383 7.02394L10.4326 8.45965L19.2363 16.0043L20.445 15.1638C23.9599 12.7183 28.2933 11.4956 32.4999 11.4956C36.7065 11.4956 41.04 12.7183 44.5547 15.1638L45.7634 16.0043L54.5671 8.45965L52.7615 7.02394Z",
    fill: "#CDD5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7637 16.0042L54.5674 8.45952L52.7616 7.02381C46.9873 2.42874 39.8977 0 32.5 0V11.4955C36.7066 11.4955 41.0401 12.7182 44.5548 15.1637L45.7637 16.0042Z",
    fill: "#98B5EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7656 30.5957H53.5742V57.3828H49.7656V30.5957Z",
    fill: "#F2F4FE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4258 30.5957H15.2344V57.3828H11.4258V30.5957Z",
    fill: "#F2F4FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersupport);
export default __webpack_public_path__ + "static/media/customersupport.ecf199e516dabc1772098e5c429924bb.svg";
export { ForwardRef as ReactComponent };